import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// dev/app-skeleton/src/pages/Unlock.tsx
// D14-DEV-v2 / SEC C' 修：真 E2EE 解锁流程。
// D15 Task 3：加入"忘记密码？"链接 → /forgot-password。
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { setRootKey } from "../lib/session-key";
import { setCurrentUserId } from "../lib/current-user";
import { base64ToBytes, deriveKEK, unwrapRootKey, zeroize } from "../crypto";
export function UnlockPage() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [pw, setPw] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        const emailTrim = email.trim().toLowerCase();
        if (!emailTrim || !/.+@.+\..+/.test(emailTrim)) {
            setErr("请输入有效邮箱");
            return;
        }
        if (pw.length < 1) {
            setErr("请输入密码");
            return;
        }
        setBusy(true);
        try {
            const r = await fetch("/api/auth/login", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: emailTrim, login_password: pw }),
            });
            if (r.status === 429) {
                setErr("请求过于频繁，请稍后再试");
                return;
            }
            if (!r.ok) {
                setErr("邮箱或密码错误");
                return;
            }
            const body = await r.json();
            if (body.crypto_version !== 1) {
                setErr(`不支持的 crypto_version=${body.crypto_version}（请升级客户端）`);
                return;
            }
            const kdfSalt = base64ToBytes(body.kdf_salt_b64);
            const rkw = base64ToBytes(body.root_key_wrapped_b64);
            const kek = await deriveKEK(pw, kdfSalt);
            let rootKey;
            try {
                rootKey = unwrapRootKey(kek, rkw, body.user_id);
            }
            catch {
                setErr("解锁失败：密钥校验未通过（可能是密码错误或数据损坏）");
                return;
            }
            try {
                await setCurrentUserId(body.user_id);
                setRootKey(rootKey);
                nav("/today", { replace: true });
            }
            catch (e) {
                zeroize(rootKey);
                throw e;
            }
        }
        catch (e) {
            console.error("[unlock] error:", e);
            setErr("网络错误，请检查连接后重试");
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsxs("main", { className: "min-h-screen flex flex-col items-center justify-center px-md", "data-testid": "page-unlock", children: [_jsx("img", { src: "/icons/icon-192.png", alt: "", width: 96, height: 96, style: { imageRendering: "pixelated" } }), _jsx("h1", { className: "text-2xl font-medium mt-md", children: "\u89E3\u9501\u65E5\u8BB0" }), _jsx("p", { className: "text-text-muted text-sm mt-sm text-center max-w-xs", children: "\u6211\u4EEC\u65E0\u6CD5\u6062\u590D\u60A8\u7684\u5BC6\u7801\u6216\u6570\u636E \u2014\u2014 \u8BF7\u59A5\u5584\u4FDD\u7BA1\u3002" }), _jsxs("form", { onSubmit: onSubmit, className: "flex flex-col gap-sm mt-xl w-full max-w-xs", children: [_jsx("input", { type: "email", placeholder: "\u90AE\u7BB1", value: email, onChange: (e) => { setEmail(e.target.value); setErr(""); }, className: "card px-md py-sm bg-surface text-text", style: { minHeight: 44 }, autoComplete: "email", "aria-label": "\u90AE\u7BB1", "data-testid": "input-email", required: true }), _jsx("input", { type: "password", placeholder: "\u4E3B\u5BC6\u7801", value: pw, onChange: (e) => { setPw(e.target.value); setErr(""); }, className: "card px-md py-sm bg-surface text-text", style: { minHeight: 44 }, autoComplete: "current-password", "aria-label": "\u4E3B\u5BC6\u7801", "data-testid": "input-password", required: true }), err && _jsx("div", { className: "text-danger text-sm", role: "alert", "data-testid": "unlock-err", children: err }), _jsx("button", { type: "submit", className: "btn btn-primary", style: { minHeight: 44 }, disabled: busy, "data-testid": "btn-unlock", children: busy ? "解锁中…" : "解锁" })] }), _jsx("p", { className: "text-text-muted text-xs mt-xl text-center max-w-xs", children: "Argon2id \u5728\u672C\u673A\u6D3E\u751F\u5BC6\u94A5 \u00B7 \u9996\u6B21\u89E3\u9501\u53EF\u80FD\u9700\u8981 1-2 \u79D2\u3002" }), _jsxs("div", { className: "flex items-center gap-md mt-md", children: [_jsx(Link, { to: "/signup", className: "text-sm text-text-muted underline", "data-testid": "link-signup", children: "\u8FD8\u6CA1\u8D26\u6237\uFF1F\u53BB\u6CE8\u518C" }), _jsx("span", { className: "text-text-muted text-xs", children: "\u00B7" }), _jsx(Link, { to: "/forgot-password", className: "text-sm text-text-muted underline", "data-testid": "link-forgot", children: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F" })] })] }));
}
